<template>
    <v-app v-if="isInitialized">
        <div id="container">

            <v-row>
                <v-img
                        alt="GameEnable"
                        class="shrink mr-2"
                        contain
                        src="../assets/logo/one-line-dark.svg"
                        transition="scale-transition"
                        width="130"
                        style="position:absolute;left: 0px; top: 0; margin: 18px 18px 10px;"
                />
                <div v-if="currentPage === 'not-authenticated'" class="view not-authenticated" style="padding:80px 23px;">

                    <div style="padding-top:50px">
                        <div style="text-align:center;color:#fff;margin-bottom:10px;">Sign in to continue</div>
                        <sign-in-button @completed="signInCompleted" :source="'extension'" ></sign-in-button>
						<div v-if="failedToLogin"><p style="color:red">Failed to sign in</p></div> 

                    </div>


                </div>

                <div v-if="currentPage === 'authenticated-no-subscription'" class="view authenticated-no-subscription">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    icon color="deep-orange" class="sign-out"
                                    v-bind="attrs"
                                    v-on="on"
                            >
                                <v-icon color="#fff">mdi-account-circle</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="padding:0;">
                            <v-list-item
                                    style="cursor:pointer;"
                                    v-for="(item, index) in [{title: 'signout'}]"
                                    :key="index"
                                    @click="signout"

                            >
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <span v-if="!paymentFormOpen">

                             <v-alert
                            icon="mdi-exclamation"
                            prominent
                            text
                            type="Warning"
                            style="margin-top:30px;"
                    >
                        <div style="margin-left:10px;">No subscription</div>
                    </v-alert>
                        <v-btn class="action-button" id="purchase-button" style="width:250px!important;" @click="paymentFormOpen=true" v-text="'Get subscription'"> </v-btn>
                    </span>



					
					<payment-form v-if="paymentFormOpen" :dark-theme="true" :source="'extension'" :sign-in-token="signInToken" @completed="onLoadPaymentData"></payment-form>
					
                </div>

                <div v-if="currentPage === 'authenticated-with-subscription'" class="view authenticated-with-subscription">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    icon color="deep-orange" class="sign-out"
                                    v-bind="attrs"
                                    v-on="on"
                            >
                                <v-icon color="#fff">mdi-account-circle</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="padding:0;">
                            <v-list-item
                                    style="cursor:pointer;"
                                    v-for="(item, index) in [{title: 'signout'}]"
                                    :key="index"
                                    @click="signout"

                            >
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                    <v-alert
                            v-if="connected"
                            icon="mdi-check-network"
                            prominent
                            text
                            type="success"
                    >
                        <div    style="margin-left:10px;"> Connected <small v-if="false">({{this.serverLocation}})</small></div>
                    </v-alert>

                    <v-alert
                            v-if="connecting"
                            icon="mdi-blabla-no-icon"
                            prominent
                            text
                            type="info"
                    >
                        <v-progress-circular
                                style="position: absolute; left: 24px; top: 23px; color: #2196f3 !important;"
                                indeterminate
                                color="red"
                        ></v-progress-circular>
                        <div    style="margin-left:10px;"> Finding fastest server</div>
                    </v-alert>
                    <v-alert
                            v-if="!connected && !connecting"
                            icon="mdi-close-network"
                            prominent
                            text
                            type="error"

                    >
                        <div    style="margin-left:10px;">Disconnected</div>
                    </v-alert>

                    <v-alert
                            v-if="false"
                            class="time-block"
                            color="grey"

                            icon="mdi-clock"

                            prominent
                    >
                        <div    style="margin-left:10px;">{{connecteTimeUi}}</div>

                    </v-alert>
                    <v-btn
                            :loading="connecting"
                            :disabled="connecting" class="action-button" id="connect-button" v-text="connecting? '' : (connected? 'Disconnect' : 'Connect')"
                           @click="connect"></v-btn>
                </div>

            </v-row>


        </div>
    </v-app>
</template>

<style scoped>

    .hide {
        display: none;
    }

    .view {

        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 60px 23px 0 23px;
    }

    .authenticated-no-subscription #purchase-button {

        bottom: 30px;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;

    }

    .authenticated-with-subscription #connect-button {

        bottom: 30px;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;

    }

    .authenticated-with-subscription .time-block * {

        color: #fff;

    }

    .authenticated-no-subscription .no-subscription {

        position: absolute;
        top: 158px;
        left: 0;
        right: 0;
        margin: auto;
        width: 160px;
        padding: 3px;
        border-radius: 3px;
        border: 1px solid orange;
        color: orange;
        text-align: center;
        font-size: 14px;
    }

    .not-authenticated #purchase-button {

        width: 230px !important;
        position: relative;
        margin: 0 auto;

    }

    #container {

        background: #444;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;

    }

    .sign-out {

        position: absolute;
        right: 15px;
        top: 10px;
        color: #fff;
        font-size: 14px;
        font-weight: 200;

    }

    .action-button{
        width: 170px!important;
        border-radius: 50px!important;
    }

    .account-name {

        position: absolute;
        left: 10px;
        top: -7px;
        color: #fff;
        font-size: 14px;
        font-weight: 400;

    }




</style>
<style>

</style>
<script>
    // @ is an alias to /src
    import Vue from 'vue';
    import PaymentForm from '../components/paymentForm'
    import SignInButton from '../components/signInButton'
    import config from '../config'
    
	export default {
        name: 'Home',
        props: ['user'],
        components: {
            PaymentForm,
            SignInButton
		},
        created(){
            Vue.$Tawk.disable();
        },
        async beforeMount() {

            //fixing a bug with vutify, adding overflow hidden to body
            const overflowStyle = document.createElement('style');
            overflowStyle.innerHTML = 'body,html{overflow:hidden!important}';
            this.head.append(overflowStyle);

            this.signInToken = localStorage.extensionSignInToken || undefined;
			this.connected = this.$route.query.active.toUpperCase() == 'TRUE';
            this.authenticated = this.$route.query.authenticated.toUpperCase() == 'TRUE' && this.signInToken;
            this.haveSubscription = this.$route.query.haveSubscription.toUpperCase() == 'TRUE';
			this.connectedTime = {seconds: parseInt(this.$route.query.time)};
            this.serverLocation = this.$route.query.serverLocation || '...';
			this.customerEmail = this.$route.query.customerEmail || undefined;


            if(this.authenticated){

                const response = await fetch(`${config.serverURL}/account/sync`, {
                    method: 'POST',
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({userToken: this.signInToken})
                });

                const payload = await response.json();
                this.haveSubscription = payload.haveSubscription;
                this.currentPage = this.haveSubscription? 'authenticated-with-subscription' : 'authenticated-no-subscription';

                if(!this.haveSubscription){
                    this.connected = false;
                    window.top.postMessage({type: 'activeChange', active: this.connected}, '*');
                }

            }

            this.isInitialized = true;

            if(this.connected){

                this.startCounter();

            }

            window.addEventListener('message', (event) => {

                const res = event.data;

                switch(res.type){

                    case 'activeChange':

                        this.connecting = false;
                        this.connected = res.active;
                        this.serverLocation = res.serverLocation;
                        if(!this.connected){

                            clearInterval(this.counterIntervalId);

                        }else{

                            this.startCounter();

                        }

                        break;
					case 'authorizationChange':
						
						this.connected = res.active;
						this.authenticated = res.authenticated;
						this.haveSubscription = res.haveSubscription;
						
						if (this.authenticated) {
							this.currentPage = this.haveSubscription ? 'authenticated-with-subscription' : 'authenticated-no-subscription';
						}
						else {
							this.currentPage = 'not-authenticated';
						}
						
						break;
						

                }




            });

		},

        data: () => ({
            connected: false,
            connectedTime: 0,
            connecting: false,
            counterIntervalId: -1,
            currentPage: 'not-authenticated',
            haveSubscription: false,
            serverLocation: 'Unknown',
			failedToLogin: false,
            paymentFormOpen: false,
            isInitialized: false
        }),
        computed: {

            connecteTimeUi(){

                let diff = this.connectedTime.seconds * 1000;


                const days = Math.floor(diff / (1000 * 60 * 60 * 24));
                diff -=  days * (1000 * 60 * 60 * 24);

                const hours = Math.floor(diff / (1000 * 60 * 60));
                diff -= hours * (1000 * 60 * 60);

                const mins = Math.floor(diff / (1000 * 60));
                diff -= mins * (1000 * 60);

                const seconds = Math.floor(diff / (1000));
                diff -= seconds * (1000);

                return `${days}:${hours}:${mins}:${seconds}`;

            }

        },
        methods: {

            async signInCompleted({token, haveSubscription, email}){

                this.signInToken = token;
                localStorage.extensionSignInToken = token;

				this.onAuthChange({token, haveSubscription, email});

            },

            startCounter(){

                this.counterIntervalId = setInterval(() => {

                    this.connectedTime.seconds++;

                    this.connectedTime = {...this.connectedTime};
                }, 1000);

            },

            onAuthChange({token, haveSubscription, email}){

				window.top.postMessage({type: 'authorizationChange', token, haveSubscription, email}, '*');

            }, 
			onSubscriptionChange(hasSubscription){

               window.top.postMessage({type: 'subscriptionChange', hasSubscription}, '*');

            },

            connect() {

                window.top.postMessage({type: 'activeChange', active: !this.connected}, '*');
                this.connecting = true;

            },

            signout() {

                this.onAuthChange(false);
                this.currentPage = 'not-authenticated';
                this.connected = false;
                this.$gapi.signOut()
                  .then(() => {
                	console.log('User disconnected.')
                  })

            },
			
			async onLoadPaymentData (responseJSON) {

                switch(responseJSON.status) {
                    case 'AUTHENTICATED_WITH_SUBSCRIPTION':
                        this.haveSubscription = true;
                        this.currentPage = 'authenticated-with-subscription';
                        break;
                    case 'AUTHENTICATED_NO_SUBSCRIPTION':
                        this.haveSubscription = false;
                        this.currentPage = 'authenticated-no-subscription';
                        break;
                }
                this.onSubscriptionChange(this.haveSubscription);

			}

        }
    }
</script>
